import { useQuery } from '@tanstack/react-query';
import axiosInstance from '../../utils/axios';
import { SUBSCRIBE_PACKAGE_LIST } from 'src/constants/queryKeys';

export const networkGetSubscribePackageInfo = async (planetId) => {
  const res = await axiosInstance.post(`SubscribePackage/Info/${planetId}`);
  return res;
};

export const networkGetSubscribePackageList = async (payload, pageIndex = 0, pageSize = 50) => {
  const res = await axiosInstance.post(`SubscribePackage/List/${pageIndex}/${pageSize}`, payload);
  return res;
};

export function useFetchSubscribePackageList(payload, pageIndex = 0, pageSize = 50) {
  return useQuery({
    queryKey: [SUBSCRIBE_PACKAGE_LIST, payload, pageIndex],
    queryFn: () => networkGetSubscribePackageList(payload, pageIndex, pageSize),
  });
}

export const networkUpdateSubscribePackage = async (planetId, payload) => {
  const res = await axiosInstance.post(`SubscribePackage/Update/${planetId}`, payload);
  return res;
};

export const networkRemoveSubscribePackage = async (planetId) => {
  const res = await axiosInstance.post(`SubscribePackage/Remove/${planetId}`);
  return res;
};

export const networkCreateSubscribePackage = async (payload) => {
  const res = await axiosInstance.post('SubscribePackage/Insert', payload);
  return res;
};
